/* src/components/utils/rutValidator.js - Modificado el 04-02-2026 */
/* -------------- validación oficial de RUT chileno -------------- */

export const validarRut = (rut) => {
  if (!rut || typeof rut !== "string") return false;

  const valor = rut.replace(/\./g, "").replace("-", "").toUpperCase();

  if (valor.length < 2) return false;

  const cuerpo = valor.slice(0, -1);
  const dv = valor.slice(-1);

  let suma = 0;
  let multiplo = 2;

  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += Number(cuerpo[i]) * multiplo;
    multiplo = multiplo < 7 ? multiplo + 1 : 2;
  }

  let dvEsperado = 11 - (suma % 11);

  dvEsperado =
    dvEsperado === 11
      ? "0"
      : dvEsperado === 10
      ? "K"
      : dvEsperado.toString();

  return dv === dvEsperado;
};
